import { AJOUTE_URL_CLIENT, SUPRIMER_URL_CLIENT } from '../types/typeUrlClient';

export const AjouteUrlClient = (url) => {
    return {
        type: AJOUTE_URL_CLIENT,
        payload: url
    }
}

export const suprimerUrlClient = (url) => {
    return {
        type: SUPRIMER_URL_CLIENT,
        payload: url
    }
}